import {BlackoutDateProps, NewBlackoutDateProps} from "../../../types/BlackoutPeriod";

export const checkTimeDifference = (selectedPeriodType: 1 | 2, formValues: NewBlackoutDateProps) => {
    if(selectedPeriodType === 1) {
        let dayDifference = formValues.toDay! - formValues.fromDay!
        if(dayDifference < 0) dayDifference += 7;
        let hourDifference = formValues.toDayTime! - formValues.fromDayTime!;
        if(hourDifference <= 0) {
            if(dayDifference === 0) {
                if(hourDifference === 0) {
                    dayDifference = 7;
                } else {
                    dayDifference = 6;
                    hourDifference += 24;
                }
            } else {
                if(hourDifference !== 0) {
                    dayDifference -= 1;
                    hourDifference = hourDifference += 24;
                }
            }
        }

        return dayDifference*24 + hourDifference;
    } else {
        return 1;
    }
}